import { createContext, useEffect, useState } from "react";

const MyContext = createContext();

const MyProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);
    const [listaEmpresa, setListaEmpresa] = useState([]);
    const [tpEmpresa, setTpEmpresa] = useState(null);
    const [listaCarrinho, setListaCarrinho] = useState([]);
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('logged') === 'true';
    });

    const getUserAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            
            setAuth({
                idUsuario: user.id,
                idFuncionario: user.id_funcionario,
                nome: user.nome,
                email: user.email,
                tipo: user.tipo,
                mestre: user.mestre,
            });
        }
    };

    const getCarrinhoProdutos = ()=>{
        const data = localStorage.getItem('carrinhoProdutos');

        if(data != null){
            setListaCarrinho(JSON.parse(data));
        }
    };

    const getInfoEmpresa = ()=>{
        const data = localStorage.getItem('empresa');
        const data2 = localStorage.getItem('infoEmpresa');

        if(data != null){
            setListaEmpresa(JSON.parse(data));
        }

        if(data2 != null){
            setTpEmpresa(data2);
        }
    };

    useEffect(()=>{
        getUserAuth();
        getCarrinhoProdutos();
        getInfoEmpresa();
    }, []);

    return (
        <MyContext.Provider
            value={{
                auth, setAuth, isAuthenticated, setIsAuthenticated, listaCarrinho, setListaCarrinho, listaEmpresa, setListaEmpresa,
                tpEmpresa
            }}
        >
            { children }
        </MyContext.Provider>
    );
}

export { MyProvider, MyContext };

